import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Experience from "@/components/landing/Experience";
import Requirements from "@/components/landing/Requirements";
import Rates from "@/components/landing/Rates";
import ApplicationForm from "@/components/landing/ApplicationForm";
import CastingVision from "@/components/landing/CastingVision";
import Footer from "@/components/landing/Footer";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App bg-[#0a0a0a] text-[#cccccc]" data-testid="app-root">
        <div className="grain-overlay" aria-hidden="true" />
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#121212",
              border: "1px solid #2a2a2a",
              color: "#fff",
            },
          }}
        />
        <Header />
        <main>
          <Hero />
          <Experience />
          <Requirements />
          <Rates />
          <ApplicationForm />
          <CastingVision />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}

export default App;
